export default __webpack_public_path__ + "static/media/danger.50deca31.svg";